export default __webpack_public_path__ + "static/media/credit-card 1.15066b1e.svg";